/**
 * Business Invoice — Atelier Toon
 *
 * Winkelwagen-blok "Ik bestel namens een bedrijf": toont bedrijfsnaam +
 * btw-nummer velden en zet ze mee als cart attributes (attributes[Bedrijfsnaam],
 * attributes[Btw-nummer]) zodat ze in de order terechtkomen. Deze gegevens
 * worden buiten dit theme (VIES-check + MoneyBird-facturatie) verder verwerkt.
 */
class BusinessInvoice extends HTMLElement {
  constructor() {
    super();
    this.toggle = this.querySelector('#Cart-business-toggle');
    this.fields = this.querySelector('#Cart-business-fields');
    this.inputs = this.fields ? this.fields.querySelectorAll('input[type="text"]') : [];

    if (!this.toggle || !this.fields) return;

    this.toggle.addEventListener('change', this.sync.bind(this));
    this.sync();
  }

  sync() {
    const checked = this.toggle.checked;
    this.fields.hidden = !checked;
    this.inputs.forEach((input) => {
      input.disabled = !checked;
    });
  }
}

customElements.define('business-invoice', BusinessInvoice);
